import React from "react";

const Fotter = () => {
  return (
    <footer className="bg-dark text-white text-center py-3 mt-auto">
      <p className="mb-1">
        © 2024-{new Date().getFullYear()} FlawSkin Private Limited. All Rights
        Reserved.
      </p>

    </footer>
  );
};

export default Fotter;
